import type { ReactNode } from "react";
import { colors, semanticColors, radius, spacing, heights, typography, shadows } from "@/styles/tokens";

export function ChangeNotificationStack({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="quote-change-notifications"
      style={{
        position: "static",
        width: "100%",
        minWidth: 0,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: spacing[8],
        marginTop: spacing[8],
      }}
    >
      {children}
    </div>
  );
}

export function UndoBar({
  count,
  onUndo,
}: {
  count: number;
  onUndo: () => void;
}) {
  if (count <= 0) return null;
  return (
    <div
      data-testid="undo-bar"
      style={{
        position: "static",
        width: "100%",
        minWidth: 0,
        minHeight: heights.control,
        boxSizing: "border-box",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: spacing[16],
        padding: `0 ${spacing[16]}px`,
        backgroundColor: semanticColors.darkSurfaceBg,
        color: semanticColors.darkSurfaceText,
        borderRadius: radius.base,
        fontSize: typography.fontSize.sm,
        boxShadow: shadows.toast,
      }}
    >
      <span data-testid="undo-bar-count" className="tabular-nums">
        {count} {count === 1 ? "change" : "changes"}
      </span>
      <button
        data-testid="undo-bar-button"
        onClick={onUndo}
        style={{
          background: "transparent",
          border: "none",
          color: colors.indigo400,
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
          cursor: "pointer",
          padding: 0,
          flexShrink: 0,
        }}
      >
        Undo
      </button>
    </div>
  );
}
